<template>
<div class="tasks-panel">
	<div class="mini-ticker">
		<div class="mini-track">
			<dashboard-task-panel-tile
				v-for="(tile, i) in miniTiles"
				:key="'mini-'+i"
				class="task-tile mini-tile"
				:icon="tile.icon"
				:task-title="tile.title"
				:count="tile.count"
				:track="tile.track"
				:link="'link' in tile ? tile.link : false"
				:mini-tile="true"
				v-on:tileClick="tileClick(tile)"
			/>
		</div>
	</div>

	<div>

		<!-- Company Forms Modal -->
		<modal-dialog
			:style="{marginTop: companyFormsModalVisible ? '30px' : 0}"
			:modal-visible="companyFormsModalVisible"
			title="Company Form Invitations"
			modal-size="modal-lg"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="companyFormsModalVisible = false">

			<table-list
				record-name="Company Form"
				:fields="[
					{ label: 'Form Description', key: 'formDescription' },
					{ label: 'Project/Service',  key: 'jobNum', type: 'external-link' },
					{ label: 'Equipment',        key: 'equipmentDescription' }
				]"
				:records="mutatedCompanyForms"
				:sortable="true"
				:loading="companyFormsLoading"
				:has-edit="true"
				edit-button-text="Open"
				v-on:edit="doCompanyForm">

			</table-list>

		</modal-dialog>

		<!-- Reviewable RFIs Modal -->
		<modal-dialog
			:style="{marginTop: reviewableRfisModalVisible ? '30px' : 0}"
			:modal-visible="reviewableRfisModalVisible"
			title="RFIs to Review"
			modal-size="modal-lg"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="reviewableRfisModalVisible = false">

			<table-list
				record-name="RFI"
				:fields="rfisReviewTableFields"
				:records="mutatedReviewableRfisForModal"
				:sortable="true"
				:loading="reviewableRfisLoading"
				:has-edit="true"
				id-field="slug"
				v-on:edit="editReviewableRfi">
			</table-list>

		</modal-dialog>
		
		<!-- Locates Modal -->
		<modal-dialog
			:style="{marginTop: locatesModalVisible ? '30px' : 0}"
			:modal-visible="locatesModalVisible"
			title="Locates Expiring in the Next 5 Days"
			modal-size="modal-lg"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="locatesModalVisible = false">

			<table-list
				record-name="Locate"
				has-edit="locates/"
				id-field="ticket_num"
				edit-button-text="View"
				edit-button-icon="fa-eye"
				:other-buttons="[
				{
					class: 'btn-light',
					click: 'openMarkLocateModal',
					icon: 'fa-marker',
					title: 'Mark',
					text: 'Mark'
				}
				]"
				v-on:otherButtonClick="otherButtonClick"
				:fields="[
					{label: 'Ticket #', key: 'ticket_num'},
					{label: 'Project/Service',key:'jobName'},
					{label: 'Expiry Date',key:'fullExpiryDate'},
					{label: 'Refresh Date',key:'refresh_date'},
					{label: 'Action',key:'fullAction',align:'center'},
				]"
				:records="mutatedLocates"
				:sortable="true">

			</table-list>

		</modal-dialog>

		<!-- Mark Locates Modal -->
		<modal-dialog
			:style="{marginTop: markLocateModal.isVisible ? '30px' : 0}"
			class="text-center"
			:modal-visible="markLocateModal.isVisible"
			title="Mark Locate"
			:submit-visible="true"
			cancel-button-text="Close"
			v-on:confirm="saveLocateMark"
			v-on:closeModal="markLocateModal.isVisible = false">

			<h3>Please select an action tag for this locate</h3>

			<button-group
				:value="markLocateModal.action"
				v-on:change="changeLocateAction"
				:buttons="[
					{value: 'Refresh', text: 'Refresh'},
					{value: 'Hold', text: 'Hold'},
					{value: 'Close', text: 'Close'}
			]">
			</button-group>

		</modal-dialog>

		<!-- Archive Services Modal -->
		<modal-dialog
			:style="{marginTop: serviceListModalVisible ? '30px' : 0}"
			:modal-visible="serviceListModalVisible"
			title="Archivable Services"
			:submit-visible="false"
			modal-size="modal-lg"
			cancel-button-text="Close"
			v-on:closeModal="serviceListModalVisible = false">

			<p>Archivable services are services that have been invoiced and haven't been clocked into for greater than 30 days</p>

			<table-list record-name="Service"
				:has-edit="true"
				edit-button-text="Archive"
				edit-button-icon="fa-archive"
				:fields="[
					{label: 'Service #',key:'jobNum',type:'link'},
					{label: 'Service Name',key:'job_name'},
					{label: 'Customer',key:'customer_name_cache'},
					{label: 'Status',key:'status'},
					//{label: 'Last Time Log',key:lastTimelog}
				]"
				:records="mutatedArchivableServices"
				v-on:edit="archiveService">

				<button class="btn btn-success" v-on:click="archiveAllServices">
					<i class="fa fa-archive"></i>
					Archive All
				</button>

			</table-list>

		</modal-dialog>

		<!-- Archivable Projects Modal -->
		<modal-dialog
			:style="{marginTop: projectsListModalVisible ? '30px' : 0}"
			:modal-visible="projectsListModalVisible"
			title="Archivable Projects"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="projectsListModalVisible = false">

			<p>Archivable projects are projects that have been marked as complete for greater than 60 days</p>

			<table-list record-name="Project"
				:has-edit="true"
				edit-button-text="Archive"
				edit-button-icon="fa-archive"
				:fields="[
					{label: 'Project #',key:'jobNum',type:'link'},
					{label: 'Project Name',key:'job_name'},
					{label: 'Completed',key:'date_completed'},
					//{label: 'Last Time Log',key:lastTimelog}
				]"
				:records="mutatedArchivableProjects"
				v-on:edit="archiveProject">

				<button class="btn btn-success" v-on:click="archiveAllProjects">
					<i class="fa fa-archive"></i>
					Archive All
				</button>

			</table-list>

		</modal-dialog>

		<!----- Incomplete Services Modal ----->
		<modal-dialog
			:style="{marginTop: incompleteServicesModal.visible ? '30px' : 0}"
			:modal-visible="incompleteServicesModal.visible"
			title="Incomplete Services"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="incompleteServicesModal.visible = false">

			<p>These are services that have been marked as "Incomplete"</p>

			<table-list
				v-if="!incompleteServicesModal.service"
				record-name="Service"
				:fields="[
					{label: 'Service #',    key:'jobNum', type:'link'},
					{label: 'Service Name', key:'job_name'},
					{label: 'Status',       key:'status'}
				]"
				:records="mutatedIncompleteServices"
				:other-buttons="[
					{
						class: 'btn-light',
						click: 'openNotes',
						icon: 'fa-pen',
						text: 'View Notes',
						condition: ['hasInternalNotes', true]
					}
				]"
				v-on:openNotes="openIncompleteServiceNotes">
			</table-list>

			<div v-else class="card p-3">
				<div class="d-flex justify-content-between mb-2">
					<router-link :to="incompleteServicesModal.service.jobNum.link">
						#{{incompleteServicesModal.service.job_num}}: {{incompleteServicesModal.service.job_name}}
					</router-link>

					<i class="fa fa-times icon-button close-button" v-on:click="incompleteServicesModal.service = null"></i>
				</div>

				<span class="text-danger mb-2">{{incompleteServicesModal.service.status}}</span>

				{{incompleteServicesModal.service.internal_notes}}
			</div>

		</modal-dialog>

		<!----- Unseen Invoices Modal ----->
		<modal-dialog
			:style="{marginTop: unseenInvoicesModal.visible ? '30px' : 0}"
			:modal-visible="unseenInvoicesModal.visible"
			:title="'Invoices Unopened by Customer for ' + unseenDays + ' days'"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="unseenInvoicesModal.visible = false">

			<p>These are invoices that have been sent to customers, but haven't been opened by them in {{ unseenDays }} days or longer. You may consider following up manually.</p>

			<template>

				<table-list record-name="Invoice"
					:fields="[
						{label: 'Invoice #',key:'invoiceNum',type:'link'},
						{label: 'Customer',key:'customerName'},
						{label: 'First Issued',key:'firstIssued'}
					]"
					:loading="unseenInvoicesModal.spinner"
					:records="mutatedInvoices">
				</table-list>

			</template>

		</modal-dialog>

		<modal-dialog	
			:style="{marginTop: vacationRequestsModal.visible ? '30px' : 0}"
			:modal-visible="vacationRequestsModal.visible"
			title="Vacation Requests"
			:submit-visible="false"
			cancel-button-text="Close"
			v-on:closeModal="vacationRequestsModal.visible = false">

			<p>These are vacation requests that have not yet been addressed:</p>

			<table-list record-name="Vacation Request"
				:fields="[
					{label: 'Employee', key: 'userFullName'},
					{label: 'Note', key: 'notes'},
					{label: 'From', key: 'startTimeFormatted'},
					{label: 'Until', key: 'endTimeFormatted'}
				]"
				:other-buttons="[
					{
						text: 'Apr',
						click: 'approveVacation',
						icon: 'fa-check',
						class: 'btn-primary',
						title: 'Approve vacation request'
					},
					{
						text: 'Reject',
						click: 'rejectVacation',
						icon: 'fa-check',
						class: 'btn-dark',
						title: 'Reject vacation request'
					}
				]"
				:records="mutatedVacationRequests"
				:loading="vacationRequestsModal.spinner"
				v-on:approveVacation="approveVacation"
				v-on:rejectVacation="rejectVacation">
			</table-list>

		</modal-dialog>

		<modal-dialog	
			:style="{marginTop: confirmModal.visible ? '30px' : 0}"
			:modal-visible="confirmModal.visible"
			:title="confirmModal.title"
			confirm-button-text="Confirm"
			cancel-button-text="Cancel"
			v-on:confirm="actionConfirmed"
			v-on:closeModal="confirmModal.visible = false">

			{{confirmModal.prompt}}

		</modal-dialog>
	</div>
</div>
</template>
<script type="text/javascript">

import DashboardTaskPanelTile from "@/components/DashboardTaskPanelTile"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import ButtonGroup from "@/components/ButtonGroup"

export default {
	name: "DashboardTasksPanel",
	components: {
		DashboardTaskPanelTile,
		ModalDialog,
		TableList,
		ButtonGroup
	},
	props: [
		"heading"
	],
	data() {
		return  {
			numTimeLogsToReview: 0,
			numExpensesToReview: 0,
			numRfisToReview: 0,
			numCompanyFormsToReview: 0,
			//numLocatesToReview: 0,	Now a computed variable
			numServicesArchivable: 0,
			numProjectsArchivable: 0,
			numServicesIncomplete: 0,
			numVacationRequests: 0,
			numUnseenInvoices: 0,
			unseenDays: 4,
			companyForms: [],
			ticketIDs: [],
			ticketsToReview: [],
			mutatedLocates: [],
			archivableServices: [],
			archivableProjects: [],
			incompleteServices: [],
			unseenInvoices: [],
			vacationRequests: [],
			reviewableRfisForModal: [],
			rfisReviewTableFields: [
				{label: "RFI #", key: "fullRfiNum"},
				{label: "Project #", key: "projectNumDisplay", type: "link"},
				{label: "RFI Status", key: "statusDisplay"}
			],
			reviewableLogsFetched: false,
			//modalDialogVisible: false,
			companyFormsModalVisible: false,
			reviewableRfisModalVisible: false,
			reviewableRfisLoading: false,
			locatesModalVisible: false,
			serviceListModalVisible: false,
			projectsListModalVisible: false,
			unseenInvoicesModal: {
				visible:  false,
				spinner: false
			},
			companyFormsLoading: false,
			markLocateModal: {			// Change mark status of locate
				isVisible: false,
				action: "",
				locate_id: ""
			},
			incompleteServicesModal: {
				visible: false,
				service: null
			},
			vacationRequestsModal: {
				visible: false,
				spinner: false
			},
			confirmModal: {
				visible: false,
				title: "",
				prompt: "",
				confirmFunction: ""
			},
			reviewableRfisModalVisible: false,
			reviewableRfisLoading: false,
			reviewableRfisForModal: [],
			rfisReviewTableFields: [
				{label: "RFI #", key: "fullRfiNum"},
				{label: "Project #", key: "projectNumDisplay", type: "link"},
				{label: "RFI Status", key: "statusDisplay"}
			]
		}
	},
	computed: {
		tiles() {
			return [
				{
					icon: "fa fa-clock",
					title: "Time Logs",
					count: this.numTimeLogsToReview,
					link: "/time-logs/review",
					track: "fin"
				},
				{
					icon: "fa fa-clipboard-check",
					title: "Forms to Sign",
					count: this.numCompanyFormsToReview,
					click: 'viewCompanyForms',
					track: "safe"
				},
				{
					icon: "fa fa-map-pin",
					title: "Locate Tickets",
					count: this.numLocatesToReview,
					click: 'viewLocates',
					track: "safe"
				},
				{
					icon: "fa fa-money-bill",
					title: "Expenses",
					count: this.numExpensesToReview,
					link: "/expenses/review",
					track: "fin"
				},
				{
					icon: "fa fa-info-circle",
					title: "RFIs",
					count: this.numRfisToReview,
					click: "viewReviewableRfis"
				},
				{
					icon: "fa fa-wrench",
					title: "Incomplete Services",
					count: this.numServicesIncomplete,
					click: 'viewIncompleteServices',
					track: "ops"
				},
				{
					icon: "fa fa-wrench",
					title: "Archivable Services",
					count: this.numServicesArchivable,
					click: 'viewServices',
					track: "ops"
				},
				{
					icon: "fa fa-cubes",
					title: "Archivable Projects",
					count: this.numProjectsArchivable,
					click: 'viewProjects',
					track: "ops"
				},
				{
					icon: "fa fa-file-invoice-dollar",
					title: "Unopened Invoices",
					titleSmall: "(older than " + this.unseenDays + " days)",
					count: this.numUnseenInvoices,
					click: 'viewUnseenInvoices',
					track: "fin"
				},
				{
					icon: "fa fa-umbrella-beach",
					title: "Vacation Requests",
					count: this.numVacationRequests,
					click: 'viewVacationRequests',
					track: "com"
				}
			]
		},
		miniTiles () {
			return this.tiles.filter(t => t.count > 0)
		},
		mutatedCompanyForms() {
			return this.companyForms.map(ack => {

				let form = ack.CompanyForm   // shorthand for clarity
				
				
				ack.formDescription = ""

				if ('FormChildTemplate' in form && form.FormChildTemplate) {
					if ('description' in form.FormChildTemplate && form.FormChildTemplate.description)
						ack.formDescription = form.FormChildTemplate.description
				}



				ack.jobNum = { text:"", link:"" }

				if ('Job' in form && form.Job) {
					if ('job_num' in form.Job && form.Job.job_num) {
						ack.jobNum.text = "Project #" + form.Job.job_num
						ack.jobNum.link = "/project/" + form.Job.slug + "/dashboard"
					}
				}

				else if ('Service' in form && form.Service) {
					if ('job_num' in form.Service && form.Service.job_num) {
						ack.jobNum.text = "Service #" + form.Service.job_num
						ack.jobNum.link = "/service/" + form.Service.slug+"/dashboard"
					}
				}


				ack.equipmentDescription = ""

				if ('Equipment' in form && form.Equipment) {
					if ('description' in form.Equipment && form.Equipment.description)
						ack.equipmentDescription = form.Equipment.description
				}


				return ack
			})
		},

		numLocatesToReview() {
			return this.ticketsToReview.filter(ticket => {
				return (ticket.action == "") ||
					(ticket.action == "Hold" && ticket.action_last_updated < this.moment().subtract(2,"weeks").format("YYYY-MM-DD HH:mm:ss"))
			}).length
		},

		mutatedIncompleteServices() {
			return this.incompleteServices.map(service => {
				service.hasInternalNotes = service.internal_notes && service.internal_notes != ""
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},

		mutatedArchivableProjects() {
			this.numProjectsArchivable

			return this.archivableProjects.map(job => {
				job.jobNum = {
					text: job.job_num,
					link: "/service/"+job.slug+"/dashboard"
				}

				return job
			})
		},
		mutatedArchivableServices() {
			if (!this.archivableServices)
				return []

			return this.archivableServices.map(service => {
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},
		mutatedInvoices() {
			let vm = this
			return this.unseenInvoices.map(inv => {

				let text = "", link = ""

				if ("Service" in inv && inv.Service) {
					text = inv.Service.job_num
					link = "/service/"+inv.Service.slug+"/invoice"
				}	
				else if ("Job" in inv && inv.Job) {
					text = inv.Job.job_num + "-" + inv.invoice_num
					link = "/project/"+inv.Job.slug+"/billing/"+inv.slug
				}
				else {
					text = inv.standalone_num
					link = "/invoice/"+inv.slug+"/details"
				}

				if (inv.manual_invoice_number)
					text = inv.manual_invoice_number

				inv.invoiceNum = {
					text,
					link
				}

				inv.customerName = ""
				if ("Customer" in inv && inv.Customer)
					inv.customerName = inv.Customer.name
				else if ("Job" in inv && inv.Job && "Customer" in inv.Job && inv.Job.Customer)
					inv.customerName = inv.Job.Customer.name
				else if ("Job" in inv && inv.Job && "customer_name_cache" in inv.Job)
					inv.customerName = inv.Job.customer_name_cache
				else if ("Service" in inv && inv.Service && "customer_name_cache" in inv.Service)
					inv.customerName = inv.Service.customer_name_cache

				inv.firstIssued = vm.formatDate(inv.date_first_issued)

				return inv
			})
		},
		mutatedVacationRequests() {
			let vm = this

			return this.vacationRequests.map(event => {
				event.userFullName = event.User.first_name + " " + event.User.last_name

				event.startTimeFormatted = vm.formatDateTimeToLocal(event.start_time)
				event.endTimeFormatted = vm.formatDateTimeToLocal(event.end_time)

				return event
			})
		},
		mutatedReviewableRfisForModal() {
			return this.reviewableRfisForModal.map(rfiRow => {
				let jobNum = ""
				rfiRow.fullRfiNum = ""

				if ("Job" in rfiRow && rfiRow.Job) {
					if (rfiRow.Job.job_num) {
						jobNum = rfiRow.Job.job_num
						if (rfiRow.rfi_num != null && rfiRow.rfi_num !== "")
							rfiRow.fullRfiNum = jobNum + "-" + rfiRow.rfi_num
					}
				}

				rfiRow.statusDisplay = ""
				if (!("is_finalized" in rfiRow) || rfiRow.is_finalized != 1)
					rfiRow.statusDisplay = "Unfinalized"
				else if (rfiRow.status)
					rfiRow.statusDisplay = rfiRow.status

				rfiRow.projectNumDisplay = { text: "", link: "" }
				if ("Job" in rfiRow && rfiRow.Job) {
					if (rfiRow.Job.job_num) {
						rfiRow.projectNumDisplay.text = rfiRow.Job.job_num
						if (rfiRow.Job.slug)
							rfiRow.projectNumDisplay.link = "/project/" + rfiRow.Job.slug + "/dashboard"
					}
				}

				return rfiRow
			})
		}
	},
	methods: {
		emitTotalItemsCount() {
			let total = this.tiles.reduce((acc,tile) => !isNaN(+tile.count) ? +tile.count + acc : acc,0)

			this.$emit("totalItemsCountChange",total)
		},
		tileButtonClick(method) {
			this[method]()
		},
		tileClick(tile) {
			if (tile.click)
				this[tile.click]()
		},
		openIncompleteServiceNotes(item) {
			this.incompleteServicesModal.service = item
		},
		doCompanyForm(ackRecord) {
			let formLink = "/form/external/"+ackRecord.CompanyForm.slug+"/"+ackRecord.slug
			window.open(formLink, '_blank');
		},
		mutateLocates() {
			let vm = this

			this.mutatedLocates = this.ticketsToReview.map(ticket => {

				// Use the first locate in the ticket as a reference
				// for repeating member values
				let locate = ticket.Locate[0]

				let copyKeys = ['status', 'expiry_date', 'refresh_date']
				copyKeys.forEach(key => {
					ticket[key] = locate[key]
				})

				ticket.Locate.forEach(locate => {

					if (locate.expiry_date < ticket.expiry_date)
						ticket.expiry_date = locate.expiry_date

					if (locate.refresh_date < ticket.refresh_date)
						ticket.refresh_date = locate.refresh_date
				})

				if (ticket.expiry_date < this.moment().format("YYYY-MM-DD"))
					ticket.fullExpiryDate = "<span class='text-danger'>" + ticket.expiry_date + "</span>"
				else
					ticket.fullExpiryDate = ticket.expiry_date

				if ('Job' in ticket && ticket.Job)
					ticket.jobName = ticket.Job.job_name
				else if ('Service' in ticket && ticket.Service)
					ticket.jobName = ticket.Service.job_name
				else
					ticket.jobName = ""

				let actionIcon = ""
				let actionColor = ""

				if (ticket.action == 'Refresh') {
					actionIcon = "fa fa-sync"
					actionColor = "text-success"
				} else if (ticket.action == 'Hold') {
					actionIcon = "fa fa-pause-circle"
					actionColor = "text-warning"
				} else if (ticket.action == 'Close') {
					actionIcon = "fa fa-times-circle"
					actionColor = "text-danger"
				}

				ticket.fullAction = "<i class='" + actionIcon + " " + actionColor + "'>"
				return ticket

			})
			.sort((a,b) => {
				return (a.expiry_date < b.expiry_date) ? -1 : 1
			})
		},
		changeLocateAction(action) {
			this.markLocateModal.action = action
		},
		openMarkLocateModal(ticket) {
			this.markLocateModal.ticket_id = ticket.id

			if ('action' in ticket)
				this.markLocateModal.action = ticket.action

			this.markLocateModal.isVisible = true
		},
		otherButtonClick(record,action) {
			this[action](record);
		},
		saveLocateMark() {
			let vm = this

			let payload = {
				id: vm.markLocateModal.ticket_id,
				action: vm.markLocateModal.action
			}

			this.postData("LocateTicket/save", payload,true).then(response => {
				if (response.success){
					// Success? Find locate in list and update action directly
					let ticket = vm.ticketsToReview.find(ticket => ticket.id == vm.markLocateModal.ticket_id)
					ticket.action = vm.markLocateModal.action
					ticket.action_last_updated = vm.moment().utc().format("YYYY-MM-DD HH:mm:ss")
					vm.mutateLocates()

					// Reset modal
					vm.markLocateModal.isVisible = false
					vm.markLocateModal.ticket_id = ""
					vm.markLocateModal.action = ""
				}
			})
		},
		viewUnseenInvoices() {
			this.unseenInvoicesModal.visible = true
			this.fetchUnopenedInvoices(false)
		},
		viewVacationRequests() {
			let vm = this

			this.vacationRequestsModal.visible = true
		},
		approveVacation(event) {
			let vm = this

			let payload = {
				approved: 1,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		rejectVacation(event) {
			let vm = this

			let payload = {
				approved: 0,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		actionConfirmed(method) {
			this[this.confirmModal.confirmFunction]()
			this.confirmModal.visible = false
		},
		executeArchiveAllProjects() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableProjects.map(project => {
					return {
						id: project.id,
						archived: 1
					}
				}))
			}

			this.postData("Job/save-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" projects archived!")
					vm.fetchArchivableProjects()
				}
			})
		},
		archiveAllProjects() {
			this.confirmModal.visible = true
			this.confirmModal.title = "Archive All Projects"
			this.confirmModal.prompt = "Are you sure you want to archive all projects?"
			this.confirmModal.confirmFunction = "executeArchiveAllProjects"
		},
		archiveAllServices() {
			this.confirmModal.visible = true
			this.confirmModal.title = "Archive All Services"
			this.confirmModal.prompt = "Are you sure you want to archive all services?"
			this.confirmModal.confirmFunction = "executeArchiveAllServices"
		},
		executeArchiveAllServices() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableServices.map(service => {
					return {
						id: service.id,
						archived: 1
					}
				}))
			}

			this.postData("Service/archive-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" services archived!")
					vm.fetchArchiveableServices()
				}
			})
		},
		archiveProject(project,index) {
			let vm = this

			this.postData("Job/save",{id:project.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableProjects.findIndex(theProject => theProject.id == project.id)

					if (index){
						vm.archivableProjects.splice(index,1)
						vm.numProjectsArchivable--
					}
				}
			})
		},
		archiveService(service,index) {
			let vm = this

			this.postData("Service/save",{id:service.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableServices.findIndex(theService => theService.id == service.id)

					if (index >= 0){
						vm.archivableServices.splice(index,1)
						vm.numServicesArchivable--
					}
				}
			})
		},
		viewIncompleteServices() {
			this.incompleteServicesModal.service = null
			this.incompleteServicesModal.visible = true
		},
		viewProjects() {
			this.projectsListModalVisible = true
		},
		viewServices() {
			this.serviceListModalVisible = true
		},
		viewCompanyForms() {
			if (!this.companyForms.length)
				this.fetchCompanyForms(true)

			this.companyFormsModalVisible = true
		},
		fetchReviewableRfisCount() {
			let vm = this

			return this.getJSON("Rfi/count-reviewable-rfis").then(response => {
				if (response.success && response.data && "count" in response.data)
					vm.numRfisToReview = response.data.count
				else
					vm.numRfisToReview = 0
			})
		},
		viewReviewableRfis() {
			let vm = this

			vm.reviewableRfisModalVisible = true
			vm.reviewableRfisLoading = true
			vm.reviewableRfisForModal = []

			this.getJSON("Rfi/get-reviewable-rfis", undefined, true).then(response => {
				vm.reviewableRfisLoading = false

				if (response.success && response.data)
					vm.reviewableRfisForModal = response.data
				else
					vm.reviewableRfisForModal = []
			})
		},
		editReviewableRfi(rfiRow) {
			let jobSlug = false
			if ("Job" in rfiRow && rfiRow.Job) {
				if (rfiRow.Job.slug)
					jobSlug = rfiRow.Job.slug
			}

			if (!jobSlug || !rfiRow.slug)
				return

			this.$router.push("/project/" + jobSlug + "/rfis/" + rfiRow.slug)
			this.reviewableRfisModalVisible = false
		},
		viewLocates() {
			this.locatesModalVisible = true
		},
		fetchLocateTickets() {
			let vm = this

			let include = [
				{
					model: "Locate",
					fields: ["expiry_date", "refresh_date"]
				},
				{
					model: "Job",
					fields: ["job_name"]
				},
				{
					model: "Service",
					fields: ["job_name"]
				}
			]

			let expiryDate = this.moment().add(5,"days").format("YYYY-MM-DD")

			let paramsExpired = {
				filters: [
					["archived", 0],
					["action", 	""],
					["Locate",  true],
					["Locate.expiry_date",   true],
					["Locate.expiry_date <", expiryDate]
				],
				include: include
			}

			let paramsHold = {
				filters: [
					["archived", 0],
					["Locate",   true],
					["action", "Hold"],
					["action_last_updated", true],
					["action_last_updated <", this.moment().subtract(7,"days").format("YYYY-MM-DD HH:mm:ss")]
				],
				include: include
			}

			let promises = [
				this.getJSON("LocateTicket/mine", paramsExpired),
				this.getJSON("LocateTicket/mine", paramsHold)
			]

			Promise.all(promises).then(responses => {

				//vm.ticketsToReview = responses[0].data.concat(responses[1].data)
				let fetchedTickets = responses[0] && "data" in responses[0] && responses[0].data ? responses[0].data.concat(responses[1].data) : []

				let tickets = []
				let ticketIDs = []

				fetchedTickets.forEach(ticket => {
					ticket.Locate = ticket.Locate.filter(locate => {
						return locate.expiry_date && locate.expiry_date < expiryDate
					})

					// Unique and contains locates
					if (!ticketIDs.includes(ticket.id) && ticket.Locate.length > 0) {
						ticketIDs.push(ticket.id)
						tickets.push(ticket)
					}
				})

				vm.ticketsToReview = tickets
				vm.mutateLocates()
			})

		},
		fetchUnopenedInvoices(count) {
			let vm = this

			let sinceDays = this.unseenDays

			let baseFilters = [
				["date_first_issued <=",this.moment().subtract(sinceDays,"days").format("YYYY-MM-DD")],
				["seen_log_json",""],
				["is_paid",0],
				["last_emailed >","0000-00-00"]
			]

			let fields = ["Customer","Service","Job","id","slug","standalone_num","manual_invoice_number","invoice_num","date_first_issued"]

			let include = []

			if (!count) {
				include = [
					{
						model: "Contact",
						fields: ["name"]
					},
					{
						model: "Job",
						fields: ["slug","job_num","job_name","Customer"],
						include: ["Contact"]
					},
					{
						model: "Service",
						fields: ["slug","job_num","job_name"]
					}
				]

				vm.unseenInvoicesModal.spinner = true
			}

			let promises = [
				vm.getJSON("ServiceInvoice/get",{
					filters: [
						["finalized",1],
						["is_quote",0],
						...baseFilters
					],
					include,
					count,
					fields
				}),
				vm.getJSON("JobInvoice/get",{
					filters: [
						["is_finalized",1],
						["is_active_version",1],
						...baseFilters
					],
					include,
					count,
					fields
				})
			]

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					
					if (count) {
						vm.numUnseenInvoices = 0

						responses.forEach(response => {
							if (response.success)
								vm.numUnseenInvoices += response.count
						})
					}
					else {
						vm.unseenInvoices = [
							...responses[0].data,
							...responses[1].data
						]
					}

					vm.unseenInvoicesModal.spinner = false

					vm.emitTotalItemsCount()

					resolve(responses)

				})
			})
		},
		fetchIncompleteServices() {
			let vm = this

			const params = {
				fields: ['id', 'slug', 'status', 'job_num', 'job_name', 'internal_notes'],
				filters: [
					['archived', 0],
					['status', 'Incomplete', 'and', 'like']
				]
			}

			this.getJSON('Service/get', params).then(response => {
				if (response.success) {
					vm.incompleteServices = response.data
					vm.numServicesIncomplete = response.data.length

					vm.emitTotalItemsCount()
				}
			})
		},
		fetchArchiveableServices() {
			let vm = this

			let params = {
				filters: [
					["archived",0],
					["status", "Invoiced"],
					["TimeLog.time_out <",this.moment().subtract(30,"days").format("YYYY-MM-DD")],
					["archived",0,'or'],
					["status", "Canceled"],
				],
				include: [
					{
						model:"TimeLog",
						fields:["id","time_out"],
						orders: [
							["time_out","DESC"]
						],
						limit: 1
					},
					{
						model: "Contact",
						fields: ["id","slug","name"]
					}
				],
				fields: ["id","slug","job_name","job_num","customer_name_cache"]
			}

			this.getJSON("Service/archivable-services").then(response => {
				if (response.success) {
					vm.archivableServices = response.data
					vm.numServicesArchivable = response.data.length

					vm.emitTotalItemsCount()
				}
			})
		},
		fetchCompanyForms(fetchAll=false) {
			let vm = this

			// Make sure the widget modal shows that its loading
			this.companyFormsLoading = true

			let params = {
				filters: [
					['user_id', this.$store.userDetails.id],
					['completed_at', null],
					['CompanyForm.deleted',0]
				]
			}

			if (!fetchAll) {
				params.fields = []
				params.include = [{model: "CompanyForm",fields:["deleted"]}]
			} else {
				params.fields = ['form_id']
				params.include = [
					"UserToken",
					{
						model: 'CompanyForm',
						fields: ['expiry', 'child_template_id', 'job_id', 'service_id', 'equipment_id','deleted'],
						include: [
							{ model: 'FormChildTemplate', fields: ['description'] },
							{ model: 'Job',               fields: ['job_num'] },
							{ model: 'Service',           fields: ['job_num'] },
							{ model: 'Equipment',         fields: ['description'] },
						]
					}
				]
			}

			this.getJSON('CompanyFormAcknowledgement/get', params).then(response => {
				if (response.success) {
					vm.numCompanyFormsToReview = response.data.length

					if (fetchAll)
						vm.companyForms = response.data

					vm.emitTotalItemsCount()
				}

				vm.companyFormsLoading = false
			})
		},
		fetchVacationRequests() {
			let vm = this

			let params = {
				filters: [
					["is_vacation",1],
					["approved_by",0],
					["rejected_by",0],
					["start_time >",this.moment().subtract(18,"months").format("YYYY-MM-DD")]
				],
				fields: [
					"user_id","is_vacation","start_time","end_time","approved_by","rejected_by","notes"
				],
				include: [{
					model: "User",
					fields: ["first_name","last_name"]
				}]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					vm.vacationRequests = response.data
					vm.numVacationRequests = response.data.length

					vm.emitTotalItemsCount()
				}
			})
		},
		fetchArchivableProjects() {
			let vm = this

			let params = {
				filters: [
					["date_completed <",this.moment().subtract(60,"days").format("YYYY-MM-DD")],
					["archived",0]
				],
				fields: ["id","slug","job_num","job_name","date_completed"]
			}

			this.getJSON("Job/get",params).then(response => {
				if (response.success) {
					vm.archivableProjects = response.data
					vm.numProjectsArchivable = response.data.length

					vm.emitTotalItemsCount()
				}
			})
		}
	},
	created() {
		let vm = this

		this.emitTotalItemsCount()

		Promise.all([
			this.fetchReviewableLogs(),
			this.fetchReviewableRfisCount()
		]).then(() => {
			vm.emitTotalItemsCount()
		})
		this.fetchLocateTickets()

		if (this.hasModulePermRead('Services')) {
			this.fetchArchiveableServices()
			this.fetchIncompleteServices()
		}

		if (this.hasModulePermRead('Jobs'))
			this.fetchArchivableProjects()

		this.fetchVacationRequests()

		this.fetchUnopenedInvoices(true)
		this.fetchCompanyForms()
	}
}
</script>

<style type="text/css" scoped>
	.tasks-panel {
		margin-bottom: 1px;
		margin-left: 10px;
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.task-tile {
		margin-left: 10px;
		background-color: white;
		padding: 10px;
	}

	.mini-ticker {
		width: 100%;
		min-width: 0;
		margin: 0;
	}

	.mini-track {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.mini-tile {
		margin: 0;
		width: auto;
		flex: 0 0 auto;
		height: 100%;
	}

	@media (max-width: 899px) {
		.tasks-panel {
			min-width: 0;
			max-width: 100%;
			overflow: hidden;
		}

		.mini-ticker {
			overflow-x: auto;
			max-width: 100%;
			min-width: 0;
			scrollbar-width: none;
			-ms-overflow-style: none;
		}

		.mini-ticker::-webkit-scrollbar {
			display: none;
		}

		.mini-track {
			flex-wrap: nowrap;
			width: max-content;
		}
	}
</style>